import { render } from "./ValidateApprovisionnement.vue?vue&type=template&id=98cbf12e&ts=true"
import script from "./ValidateApprovisionnement.vue?vue&type=script&lang=ts"
export * from "./ValidateApprovisionnement.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__